module.exports = __webpack_public_path__ + "img/source2.cd9cbe1f.png";